import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StoreService<T> {
  private stateSubject: BehaviorSubject<T>;
  public state$: Observable<T>;

  constructor(initialState: T) {
    this.stateSubject = new BehaviorSubject<T>(initialState);
    this.state$ = this.stateSubject.asObservable();
  }

  getState(): T {
    return this.stateSubject.getValue();
  }

  setState(newState: T): void {
    this.stateSubject.next(newState);
  }
}
